module.exports = __webpack_public_path__ + "static/media/camion.98c10cc6.svg";